import { Check } from "lucide-react";
import { BOOKING } from "@/lib/site";
import { Reveal, Overline } from "./Reveal";
import { SiteButton } from "./SiteButton";

const included = [
  "One-hour private booking of the whole recovery area",
  "Traditional Finnish sauna",
  "Ice bath",
  "Outdoor recovery deck",
  "Up to six people total — invite five friends",
  "Additional guests A$10 each, paid individually",
  "Red-light therapy — coming soon",
];

const membershipPoints = [
  "Two one-hour private or shared sessions per week, subject to availability",
  "Three calendar months minimum",
  "Complimentary red-light therapy once commissioned",
];

const Pricing = () => {
  return (
    <section id="pricing" data-testid="pricing-section" className="py-24 md:py-32">
      <div className="mx-auto max-w-5xl px-5 sm:px-8">
        <Reveal>
          <div
            data-testid="pricing-card"
            className="relative border border-line bg-clay p-8 sm:p-12 md:p-16"
          >
            <div className="absolute top-0 left-8 sm:left-12 -translate-y-1/2 bg-rust px-4 py-1.5">
              <span className="text-xs tracking-[0.2em] uppercase font-medium text-white">
                Launch offer · Save A$10
              </span>
            </div>

            <div className="grid md:grid-cols-2 gap-12 md:gap-16">
              <div>
                <Overline>One simple session</Overline>
                <h2 className="mt-4 font-display text-3xl sm:text-4xl tracking-tight text-cream">
                  Private Recovery Session
                </h2>
                <div className="mt-8 flex items-end gap-4">
                  <span data-testid="pricing-launch-price" className="font-display text-6xl sm:text-7xl leading-none text-cream">
                    A$50
                  </span>
                  <span className="pb-2 flex flex-col">
                    <span data-testid="pricing-standard-price" className="text-lg text-stone2 line-through">
                      A$60
                    </span>
                    <span className="text-xs tracking-[0.15em] uppercase text-stone2">per session</span>
                  </span>
                </div>
                <p className="mt-6 text-sm md:text-base font-light leading-relaxed text-sand">
                  Sixty minutes. The sauna, the ice bath, the deck — all privately
                  yours. Bring up to five friends; each guest simply pays their own A$10.
                </p>
                <SiteButton
                  testid="pricing-book-button"
                  href={BOOKING.book}
                  className="mt-10 w-full sm:w-auto"
                >
                  Book a private session
                </SiteButton>
                <p className="mt-4 text-xs text-stone2">
                  Launch pricing is available for a limited time.
                </p>
              </div>

              <div className="md:border-l md:border-line md:pl-16">
                <p className="text-xs tracking-[0.25em] uppercase font-medium text-stone2">
                  What's included
                </p>
                <ul className="mt-6 space-y-4">
                  {included.map((item, i) => (
                    <li key={item} data-testid={`pricing-included-${i + 1}`} className="flex gap-3 text-sm md:text-base font-light text-sand">
                      <Check className="mt-0.5 h-4 w-4 shrink-0 text-ember" aria-hidden="true" />
                      <span>{item}</span>
                    </li>
                  ))}
                </ul>
              </div>
            </div>
          </div>
        </Reveal>

        <Reveal delay={0.1}>
          <div
            data-testid="membership-card"
            className="relative mt-10 border border-line bg-coal p-8 sm:p-10 grid md:grid-cols-2 gap-8 md:gap-12 items-center"
          >
            <div className="absolute top-0 left-8 sm:left-10 -translate-y-1/2 bg-ink border border-line px-4 py-1.5">
              <span className="text-xs tracking-[0.2em] uppercase font-medium text-ember">
                Introductory offer
              </span>
            </div>
            <div>
              <Overline>Membership</Overline>
              <h3 className="mt-3 font-display text-2xl sm:text-3xl tracking-tight text-cream">
                TEMPA Membership
              </h3>
              <div className="mt-5 flex items-end gap-3">
                <span data-testid="membership-price" className="font-display text-4xl sm:text-5xl leading-none text-cream">
                  A$100
                </span>
                <span className="pb-1 text-xs tracking-[0.15em] uppercase text-stone2">per week</span>
              </div>
              <SiteButton
                testid="membership-join-button"
                href={BOOKING.memberships}
                variant="secondary"
                className="mt-8 w-full sm:w-auto"
              >
                Join membership
              </SiteButton>
              <p className="mt-4 text-xs text-stone2">
                Already a member?{" "}
                <a href={BOOKING.account} data-testid="membership-login-link" className="underline text-sand hover:text-cream transition-colors duration-300">
                  Member login
                </a>
              </p>
            </div>
            <div className="md:border-l md:border-line md:pl-12">
              <ul className="space-y-4">
                {membershipPoints.map((item, i) => (
                  <li key={item} data-testid={`membership-point-${i + 1}`} className="flex gap-3 text-sm md:text-base font-light text-sand">
                    <Check className="mt-0.5 h-4 w-4 shrink-0 text-ember" aria-hidden="true" />
                    <span>{item}</span>
                  </li>
                ))}
              </ul>
            </div>
          </div>
        </Reveal>
      </div>
    </section>
  );
};

export default Pricing;
